export default __webpack_public_path__ + "static/media/grafema_minha-casa_10.16a9cde9.jpg";